<div class="event-component-delete-check-dialog">
  <h1 cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="cursor:move;">WARNING!</h1>
  <div class="info row center justify-center">Select the rows you want to update.</div>
  <div class="info row center justify-center">Selected rows will result in links being updated or removed.</div>
  <mat-dialog-content>
    @for (ct of component_types; track ct) {
      @if (prop_column_dict[ct.id]) {
        <table class="simple-table">
          <thead>
            <tr>
              <th class="ct" style="font-size:1rem;">Add to selection</th>
              <th class="ct" style="font-size:1rem;" >Replace selection</th>
              <th class="ct" [attr.colspan]="2 + (prop_column_dict[ct.id]?.length || 0)">
                <div>{{ct.name}}</div>
              </th>
            </tr>
            <tr style="height:30px;">
              <th class="td-checkbox" [ngClass]="{'disabled':includeAllColumnsDisabled[ct.id]}">
                <mat-checkbox matTooltip="Include this column from pasted data (only applies when many components of this type can be linked)"
                [disabled]="includeAllColumnsDisabled[ct.id]" (change)="includeColumn($event.checked, ct.id)"></mat-checkbox>
              </th>
              <th class="td-checkbox">
                <mat-checkbox matTooltip="Include this column from pasted data"
                (change)="replaceColumn($event.checked, ct.id)"></mat-checkbox>
              </th>
              @for (cp of prop_column_dict[ct.id]; track cp) {
                <th>{{column_dict[cp.id].title || cp.attributes.name}}</th>
              }
              <th class="label">Currently linked to</th>
              <th class="label" [ngClass]="{'link-remove-text': getLinkCount(ct.id, 'removed') || getLinkCount(ct.id)}">Will
                be linked to
              </th>
            </tr>
          </thead>
          <tbody>
            @for (d of component_data[ct.id]; track d) {
              <tr [ngClass]="{'include': d.include}">
                <td class="td-checkbox" [ngClass]="{'disabled':d.is_single}">
                  <mat-checkbox [ngModel]="d.include" (change)="includeCell($event.checked, d)"
                  [disabled]="d.replace || d.is_single" matTooltip="Include this value in pasted data"></mat-checkbox>
                </td>
                <td class="td-checkbox">
                  <mat-checkbox [ngModel]="d.replace" (change)="replaceCell($event.checked, d)"
                  [disabled]="d.include" matTooltip="Include this value in pasted data"></mat-checkbox>
                </td>
                @for (cp of prop_column_dict[ct.id]; track cp) {
                  <td>{{d.prop_data[cp.id]}}</td>
                }
                <td>@for (component of d.current_value; track component) {
                  <div>{{component}}</div>
                }</td>
                <td [ngClass]="{'link-remove-text': d.include}">{{d.include && !d.pasted_value ? 'Link will be removed' : d.pasted_value}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      <div class="link-info">
        <div class="info row center justify-center error">
          {{getLinkCount(ct.id, 'updated') | matchTitleToCount : 'link':'links'}} will be
          updated
        </div>
        <div
          class="info row center justify-center error">{{getLinkCount(ct.id, 'removed') | matchTitleToCount : 'link':'links'}}
          will be removed
        </div>
      </div>
    }


    <div class="row center justify-center buttons">
      <button (click)="continuePaste()"
        class="bordered-button green"
        mat-button
        style="align-self: center;margin-bottom: 14px;height: 40px;width:220px;">Continue
      </button>
      <button (click)="cancelPaste()"
        class="bordered-button grey"
        mat-button
        matTooltip="This will roll back the entire paste"
        style="align-self: center;margin-bottom: 14px;height: 40px;width:220px;">Cancel
      </button>
    </div>
  </mat-dialog-content>
</div>
